import { Component, OnInit } from '@angular/core';
import { MdDialogRef } from '@angular/material';
import { FormControl, Validators} from '@angular/forms';
import { convertNumberFromThousands, convertToThousands } from '@utils/formatter';

@Component({
  selector: 'precio-especial-dialog-component',
  templateUrl: './precio-especial-dialog.component.html',
  styleUrls: ['./precio-especial-dialog.component.scss']
})
export class PrecioEspecialDialogComponent implements OnInit {
  public data: any = {};
  public crear: boolean;
  
  priceCtrl = new FormControl('', [Validators.required, this.validateNumbers]);

  validateNumbers(control: FormControl) {
    const value = control.value;
    if (!value) {
      return null;
    }
    const numericValue = convertNumberFromThousands(value);
    return isNaN(numericValue) || (!isNaN(numericValue) && numericValue < 1) ? {error: true} : null; 
  }

  constructor(public dialogRef: MdDialogRef<PrecioEspecialDialogComponent>) {}

  ngOnInit() {
    if (this.data.price) {
      this.priceCtrl.setValue(convertToThousands(this.data.price, true));
    }
  }

  closeDialog() {
    this.dialogRef.close();
  }

  onSubmit() {
    this.priceCtrl.markAsTouched();
    if (!this.priceCtrl.valid) {
      return;
    }
    this.dialogRef.close({
      price: convertNumberFromThousands(this.priceCtrl.value)
    });
  }
}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/negocios/negocios/precio-especial-dialog.component.ts